/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_InvalidInputs */

const en_us2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

const pt_br2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um e-mail válido.`)
};

const es_419_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un correo válido.`)
};

const pt_pt2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduz um e-mail válido.`)
};

const fr_fr2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisis une adresse e-mail valide.`)
};

const de_de2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib eine gültige E-Mail-Adresse ein.`)
};

const it_it2_email_invalid = /** @type {(inputs: Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un indirizzo email valido.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Email_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const email_invalid = /** @type {((inputs?: Email_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_email_invalid(inputs)
	if (locale === "es-419") return es_419_email_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_email_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_email_invalid(inputs)
	if (locale === "de-DE") return de_de2_email_invalid(inputs)
	if (locale === "it-IT") return it_it2_email_invalid(inputs)
	return en_us2_email_invalid(inputs)
});
export { email_invalid as "email.invalid" }